import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { FileUpload } from '../../common/fileUpload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form } from 'formik';
import { getLanguage, apiPost, getHostUrl, getHostApi } from '../../../store/apiWrapper';
import { isGuid, isNullOrUndefined, isValidLanguage } from '../../../store/storeFunctions';
import { MomentDate } from "../../common/momentComponent";
import { searchInstances } from '../../../store/relationsSearchStore';
import { toast } from '../../common/toast';
import { windowActions } from '../../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from "react-router";
import BbCheckbox from '../../styling/bbCheckbox';
import BbDatePicker from "../../common/datePicker";
import BbInput from "../../styling/bbInput";
import classnames from 'classnames';
import FormMenuControl from '../../common/formMenuControl';
import Message from '../../common/message';
import Moment from 'moment';
import NoDataComponent from '../../common/noDataComponent';
import RelationLink from "../../reportSections/relations/relationLink";
import RelationsSearchInstance from "../relations/relationsSearchInstance";
import SearchTip from '../../common/searchTip';
import TabLink from '../tabLink';
import UnderlinedTitle from "../../common/underlinedTitle";

import IconAddSubject from '../../../img/icons/BBiconsPridatSubjekt';
import IconAddListOfSubjects from '../../../img/icons/BBiconsPridatSeznamSubjektu';

import './conflictOfInterest.scss';

const INPUT_TYPE = {
    addSubject: "addSubject",
    bulk: "bulk",
}

class ConflictOfInterestAddSubject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            totalCount: null,
            isLoading: false,
            selectAll: false,
            selected: [],
            country: null,
            applicableDate: null,
            notFoundFile: null,
            errorfile: null,
            exception: null,
            showResult: false,
            inputType: INPUT_TYPE.addSubject,
            errorMessage: null
        };
    }

    changeInputType(value) {
        if (value !== this.state.inputType) {
            this.setState({
                inputType: value, data: [],
                totalCount: null,
                selectAll: false,
                selected: [],
                country: null,
                showResult: false,
                errorfile: null,
                exception: null,
                applicableDate: null,
                notFoundFile: null
            });
            this.props.closeAll();
        }
    }

    render() {
        return (
            <>
                <div className="columns is-desktop is-multiline">
                    <div className="column is-4-desktop tabs tabs-form-menu" style={{ fontSize: "1em" }}>
                        <FormMenuControl>
                            <ul>
                                <TabLink type={INPUT_TYPE.addSubject} selected={this.state.inputType} onSelect={(value) => this.changeInputType(value)}
                                    icon={<IconAddSubject className="tabs-icon" />} titleKey='Common.Search' hr={true} />
                                <TabLink type={INPUT_TYPE.bulk} selected={this.state.inputType} onSelect={(value) => this.changeInputType(value)}
                                    icon={<IconAddListOfSubjects className="tabs-icon" />} titleKey='Search.Common.BulkUpload' />
                            </ul>
                        </FormMenuControl>
                    </div>
                    <div className='column'>
                        {this.hasSearchTips(this.state.inputType) &&
                            <SearchTip windowId={`tips_coi_${this.state.inputType}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.inputType)} className="hide-on-mobile" style={{ marginBottom: '-0.5em', marginTop: '1em' }} />}
                        {this.state.inputType === INPUT_TYPE.addSubject && this.renderSearchForm()}
                        {this.state.inputType === INPUT_TYPE.bulk && this.renderBulkForm()}
                        {this.state.errorMessage && <div style={{ paddingTop: '1em' }}><Message type="error" message={this.state.errorMessage} /></div>}
                    </div>
                </div>
            </>
        )
    }

    renderSearchForm = () => {
        return (
            <div className="search-wrap" style={{ marginTop: "1em" }}>
                <div className={`search-content`} style={{ margin: '0em', padding: '0em' }}>
                    <div className="search-container">
                        {this.hasSearchTips(this.state.inputType) &&
                            <SearchTip windowId={`tips_coi_${this.state.inputType}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.inputType)} className="hide-on-desktop" style={{ marginBottom: '-0.5em', paddingTop: '1em', marginRight: '1em', alignSelf: 'flex-end' }} />}
                        <RelationsSearchInstance
                            instanceKey={searchInstances.conflictOfInterest}
                            onEntityCheck={(v) => this.onCheckEntity(v)}
                            onHasResults={(v) => this.onHasResults(v)}
                            scroller={this.props.scroller}
                            renderTypeTabs
                        />

                        {this.state.showResult > 0 &&
                            <Formik
                                ref={(el) => this.formRef = el}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validateOnBlur={false}
                                initialValues={{
                                    applicableDate: null
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                    this.submitSearch(values)
                                }}
                            >
                                {({ values, setFieldValue, errors }) => (
                                    <Form style={{ width: "100%" }}>
                                        <div style={{ borderTop: '1px solid rgb(222, 222, 222)' }}>
                                            {this.props.type === "reference" &&
                                                <div className="columns" style={{ margin: '0', padding: '0 3em' }}>
                                                    <div className="column is-12">
                                                        <BbInput type='custom' label={this.props.translate('Search.ConflictOfInterest.ApplicableDate')}
                                                            placeholder={{ type: 'column' }} error={errors} custom={
                                                                <BbDatePicker
                                                                    formik={this.formRef}
                                                                    field={'applicableDate'}
                                                                    value={values.applicableDate}
                                                                    formDateFormat={"YYYY-MM-DD"}
                                                                    yearsBack={120} />
                                                            } />
                                                    </div>
                                                </div>}

                                            <div className='columns m-0 is-centered has-text-centered'>
                                                <div className='column is-narrow'>
                                                    <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                                        type='submit'
                                                        style={{ fontWeight: 600 }}
                                                        disabled={this.state.isLoading || isNullOrUndefined(this.state.selected) || this.state.selected.length === 0}
                                                    >
                                                        {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Common.Add' />}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        }
                    </div>
                </div>
            </div >
        );
    }

    onCheckEntity(checkedEntities) {
        this.setState({ selected: checkedEntities, selectAll: checkedEntities.length === this.state.data.length });
    }

    onHasResults(value) {
        if (this.state.showResult !== value) {
            this.setState({ showResult: value });
        }
    }

    submitSearch(values) {
        this.setState({ applicableDate: values.applicableDate }, () => this.addSubject());
    }

    renderBulkForm = () => {
        return (
            <div className='card card-special'>
                {this.hasSearchTips(this.state.inputType) &&
                    <SearchTip windowId={`tips_coi_${this.state.inputType}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.inputType)} className="hide-on-desktop" style={{ marginBottom: '-2.5em', paddingTop: '1em', marginRight: '1em' }} />}
                <div className='card-body coi-add-subject'>
                    <Formik
                        ref={(el) => this.formRef = el}
                        enableReinitialize={true}
                        validateOnChange={false}
                        validateOnBlur={false}
                        initialValues={{
                            bulkFile: undefined
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            setSubmitting(false);
                            this.submitBulk(values)
                        }}
                    >
                        {({ values, setFieldValue, errors }) => (
                            <Form >
                                {Object.keys(errors).length > 0 && <div className="column">
                                    <Message type="error" message={this.props.translate("Error.InvalidParams")}>
                                        {this.props.translate("ConflictOfInterest.Error.Ico")}
                                    </Message>
                                </div>}
                                <div className="tile is-ancestor">
                                    <div className="tile is-vertical" >
                                        <div className="columns is-centered has-text-centered">
                                            <div className="column is-8">
                                                <div className="tile is-parent is-vertical">
                                                    <div className="tile is-child">
                                                        <label>
                                                            <b>
                                                                <Translate id='Search.Common.BulkFile' />
                                                            </b>
                                                        </label>
                                                    </div>
                                                    <div className="tile is-child">
                                                        <label>
                                                            <Translate id='Search.Common.BulkFile.Info' />
                                                        </label>
                                                    </div>
                                                    <div className="tile is-child">
                                                        <FileUpload className="fileupload-button" customLabel={true} name='bulkFile' callback={(result) => setFieldValue("bulkFile", result)}>
                                                            <a className="link-functional" id="bulk_template" href={this.getBulkTemplateUrl(this.props.type, this.props.activeLanguage.code)} style={{ padding: "1em" }}><Translate id='Search.Common.BulkTemplate' /></a>
                                                        </FileUpload>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='columns m-0 is-centered has-text-centered'>
                                    <div className='column is-narrow' style={{ paddinglLeft: 0, paddingRight: 0 }}>
                                        <button className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                                            type='reset'
                                            style={{ fontWeight: 600 }}
                                            disabled={this.state.isLoading}
                                            onClick={() => this.props.history.push(`/search/conflictOfInterest/${this.props.type}-list`)}
                                        >
                                            {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Common.Back' />}
                                        </button>
                                        <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                            type='submit'
                                            style={{ fontWeight: 600 }}
                                            disabled={this.state.isLoading}
                                        >
                                            {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : this.state.inputType === INPUT_TYPE.bulk ? <Translate id='Common.Upload' /> : <Translate id='Common.Button.Add.Subject' />}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                {this.renderFoundTable()}
            </div>
        );
    }

    submitBulk(values) {
        if (!isNullOrUndefined(values.bulkFile)) {
            this.setState({ isLoading: true })
            apiPost(`${getHostApi()}/api/conflict-of-interest/${this.props.type}/bulk`, null,
                values.bulkFile,
                (data) => this.onSuccessBulk(data.data),
                (err) => this.onError(err));
        }
    }

    onSuccessBulk(data) {
        this.setState({ data: data.subjects, notFoundFile: data.notFoundFile, errorfile: data.errorFile, exception: data.exception, isLoading: false, showResult: true, errorMessage: null }, () => this.selectAll(true))
    }

    onError(err) {
        this.setState({ errorMessage: <Translate id={err.data.error.message || "UnhappyUser.InternalServerError"} options={{ renderInnerHtml: true }} />, isLoading: false });
    }

    renderFoundTable() {
        return (
            <>
                {this.state.isLoading &&
                    <div className='card-body coi-add-subject' style={{ borderTop: '1px solid rgb(222, 222, 222)' }}>
                        <Circles />
                    </div>}
                {!this.state.isLoading && this.state.showResult &&
                    <div className='card-body coi-add-subject' style={{ borderTop: '1px solid rgb(222, 222, 222)' }}>
                        <UnderlinedTitle header={this.props.translate("ConflictOfInterest.FoundSubjects")} />
                        {this.state.errorfile &&
                            <Message type='warning' style={{ marginTop: '1em', marginBottom: '1em' }} message={<Translate id={'ConflictOfInterest.ExcelValidationError'} />} />
                        }
                        {!isNullOrUndefined(this.state.data) && this.state.data.length > 0 ?
                            <div className="responsive-table">
                                <table className="table table-report-section table-marketing-list">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "10%" }}><Translate id="Search.Common.CompanyId" /></th>
                                            <th style={{ width: "30%" }}><Translate id="Search.Common.CompanyName" /></th>
                                            <th style={{ width: "5%" }}><Translate id="Search.ConflictOfInterest.RegistrationCountry" /></th>
                                            {this.props.type === "reference" && <th><Translate id="Search.ConflictOfInterest.ApplicableDate" /></th>}
                                            <th ><Translate id="Search.ConflictOfInterest.InsertDate" /></th>
                                            <th className="with-pointer" onClick={() => this.selectAll()}><div className="coi-select-all-wrapper"><BbCheckbox style={{ fontWeight: 600 }} id="conflictOfInterest-list-all" value={this.isAllChecked()} onChange={() => this.selectAll()} /></div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.map((item) => {
                                            return (
                                                <tr key={item.entityId} className='colorize'>
                                                    <td>{item.ico}</td>
                                                    <td><RelationLink entityId={item.entityId} reports={item.reports} entityName={item.name} /></td>
                                                    <td>{isNullOrUndefined(item.country) ? this.state.country : item.country}</td>
                                                    {this.props.type === "reference" && <td><MomentDate value={isNullOrUndefined(item.applicableDate) ? this.state.applicableDate : item.applicableDate} format="L" /></td>}
                                                    <td><MomentDate value={Moment()} format="L" /></td>
                                                    <td className="coi-select-wrapper"><BbCheckbox style={{ display: "inline-flex", minHeight: "0px", lineHeight: "3em", verticalAlign: "middle" }}
                                                        id={`coi-${item.entityId}`}
                                                        name={`coi-${item.entityId}`}
                                                        value={this.state.selected.includes(item.entityId)}
                                                        onChange={e => this.onChangeCheckBox(e, item.entityId)} /></td>
                                                </tr>
                                            )

                                        })}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoDataComponent />
                        }
                        <div className="export-not-found-wrapper">
                            {!isNullOrUndefined(this.state.notFoundFile) && <a className={classnames('link-internal')}
                                href={this.getBulkTempFileUrl(this.state.notFoundFile)} target="_blank"
                            >
                                {<Translate id='ConflictOfInterest.ExportNotFoundList' />}
                            </a>}
                            {!isNullOrUndefined(this.state.errorfile) && <a className={classnames('link-internal')}
                                href={this.getBulkTempFileUrl(this.state.errorfile)} target="_blank"
                            >
                                {<Translate id='ConflictOfInterest.ExcelValidationError' />}
                            </a>}
                        </div>
                        <div className='columns m-0 is-centered has-text-centered'>
                            <div className='column is-narrow'>
                                <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    type='submit'
                                    style={{ fontWeight: 600 }}
                                    disabled={this.state.isLoading || isNullOrUndefined(this.state.data) || this.state.data.length === 0 || this.state.selected.length === 0}
                                    onClick={() => this.addSubject()}
                                >
                                    {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Common.Add' />}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }

    addSubject() {
        if (!isNullOrUndefined(this.state.selected) && this.state.selected.length > 0) {
            apiPost(`${getHostApi()}/api/conflict-of-interest/${this.props.type}/add`, null,
                this.props.type === "reference" ? this.addApplicableDate() : this.state.selected,
                (data) => { toast(this.props.translate("ConflictOfInterest.ListUpdatedSubjectsAdded").replace('{0}', this.state.selected.length), "success"); this.props.history.push(`/search/conflictOfInterest/${this.props.type}-list`); },
                (err) => this.onError(err));
        }
    }

    addApplicableDate() {
        var selected = [];
        this.state.selected.forEach(item => {
            selected = selected.concat({
                entityId: item, applicableDate: this.state.inputType === INPUT_TYPE.bulk ? this.state.data.find((element) => {
                    return element.entityId === item;
                }).applicableDate : this.state.applicableDate
            });
        });
        return selected;
    }

    selectAll(newList = false) {
        if (!isNullOrUndefined(this.state.data)) {
            var selected = [];
            if (this.state.selectAll === false || newList) {
                this.state.data.forEach(item => {
                    selected = selected.concat(item.entityId)
                });
            }
            var selectAll = this.state.selectAll === false;
            if (newList)
                selectAll = true;
            this.setState({ selectAll: selectAll, selected: selected });
        }
    }

    isAllChecked = () => {
        if (this.state.selected.length === 0) { return false };
        if (this.state.selectAll) { return true };
        return null;
    }

    onChangeCheckBox(e, entityId) {
        var selected = [];
        if (e) {
            selected = this.state.selected.concat(entityId);
            this.setState({ selected: selected, selectAll: selected.length === this.state.data.length });
        }
        else {
            selected = this.state.selected.filter(item => item !== entityId)
            this.setState({ selected: selected, selectAll: false });
        }
    }

    getAgent() {
        var agentLanguage = "";
        if (!isNullOrUndefined(this.props.user.authentication.profile))
            agentLanguage = this.props.user.authentication.profile.agentLanguage;
        else
            agentLanguage = getLanguage();

        return agentLanguage === "sk-SK" ? "SK" : "CZ";
    }

    getCountryLabels = () => {
        return [
            { label: "Common.CzechRepublic", value: "CZ" },
            { label: "Common.SlovakRepublic", value: "SK" }
        ];
    }

    getMenuLabels = () => {
        return [
            { label: "Common.Button.Add.Subject", value: "1" },
            { label: "Search.Common.Bulk", value: "2" }
        ];
    }

    getBulkTemplateUrl(type, languageCode) {
        const langCode = isValidLanguage(languageCode) ? languageCode : "sk-SK";
        return type === "reference" || type === "client" ? `${getHostApi()}/api/conflict-of-interest/${type}/template/${langCode}` : "#"
    }

    getBulkTempFileUrl(file) {
        return !isGuid(file) ? "#" : `${getHostUrl()}/files/conflict-of-interest/file/${file}`;
    }

    hasSearchTips(searchType) {
        return searchType === INPUT_TYPE.addSubject;
    }

    getSearchTipsModel = (searchType) => {
        return searchType === INPUT_TYPE.addSubject ?
            { title: `${this.props.translate('Common.Search')}`, bodyHtml: this.props.translate('SearchTips.COI.AddSubject.Body') } : undefined;
    }
}

export default withRouter(withLocalize(connect(
    state => state.userContext,
    dispatch => bindActionCreators(windowActions, dispatch)
)(ConflictOfInterestAddSubject)));